import React, { useState, useEffect, useCallback, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import { POST_STATUS, s3Link } from '../../utils/constants';
import { useHistory } from 'react-router';
import useDidMountEffect from '../../utils/useDidMountEffect';
import { connect, useDispatch } from 'react-redux';
import { appendPosts, fetchPosts, resetPosts, setPostAction, setPostMedias, setPostWasReset, setSelectedPost, setSelectedPostGallery } from '../../../redux/actions';
import SilverLockIcon from '../../images/silver_lock.png';
import CloseButton from '../CloseButton';
import PostItem from "./post-item";
import ShopItem from "./shop-item";
import store from '../../../redux/reducers/reducer';
import queryString from 'query-string';
import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup';
import { styled } from '@mui/system';

const PopupBody = styled('div')(
  ({ theme }) => `
    width: max-content;
    padding: 12px 16px;
    margin: 8px;
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === 'dark' ? '#434D5B' : '#DAE2ED'};
    background-color: ${theme.palette.mode === 'dark' ? '#23242a' : '#fff'};
    box-shadow: ${theme.palette.mode === 'dark'
      ? `0px 4px 8px rgb(0 0 0 / 0.7)`
      : `0px 4px 8px rgb(0 0 0 / 0.1)`
    };
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    z-index: 1;
`,
);

const ShopContents = ({
  refetch = false,
  setRefetch = () => ({}),
  isPu = false,
  activePost,
  posts,
  user,
  action,
  showCreditCardForm,
  status = POST_STATUS.PUBLISHED,
  isLoading,
  hasMore
}) => {
  const dispatch = useDispatch();
  const perPage = 10;
  const userInformation = JSON.parse(localStorage.getItem('user'));
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [post, setPost] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [activeMedia, setActiveMedia] = useState(post.medias ?? []);
  const [activeCategory, setActiveCategory] = useState({});
  const [pu, setPu] = useState({});
  const [shopFilter, setShopFilter] = useState({
    filter: 'created_at',
    order: 'desc'
  });

  const observer = useRef();
  const cancelTokenSource = useRef();

  const lastPostElementRef = useCallback(node => {
    if (isLoading) return;
    if (observer.current) {
      observer.current.disconnect();
    }

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        setCurrentPage(currentPage => currentPage + 1);
      }
    });

    if (node) observer.current.observe(node);
    return () => {
      observer.current.disconnect();
    };
  }, [isLoading, hasMore]);

  const getPosts = async (type = 'new') => {
    const pathname = window.location.pathname.replace('/', '');
    const parsed = queryString.parse(window.location.search);
    const url = window.location.href;
    const urlParts = url.split('/');
    const parameters = urlParts[urlParts.length - 1].split('?');
    const action = parsed.action;

    // if ((parsed.postid && posts.length >= 1 && action !== 'go_to_post') || isLoading) {
    //     return false;
    // }

    if (parsed.postid) {
      history.replace({
        search: `postid=${parsed.postid}`
      });
    }

    if (type === 'new') {
      setCurrentPage(1);
    }

    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();
    cancelTokenSource.current = source;

    const paramPage = type === 'new' ? 1 : currentPage;

    const params = {
      user: pathname ?? userInformation.login,
      currentPage: paramPage,
      perPage: perPage,
      postLn: paramPage === 1 ? 0 : posts.length,
      isPu: isPu,
      status: status,
      postid: parsed?.postid,
      category_id: activeCategory && Object.keys(activeCategory).length > 0 ? activeCategory.id : '',
      pageName: parameters.length > 0 && parameters[0] ? parameters[0] : 'home', // pinned posts are excluded in homepage
      source,
      type: 'shop',
      filter: shopFilter
    };

    if (type === 'new') {
      dispatch(fetchPosts(params));
    } else {
      dispatch(appendPosts(params));
    }

    setRefetch(false);
  };

  const handleShow = (post) => {
    axios.get(`/api/posts/${post.id}/details`)
      .then((response) => {
        const pu = response.data.post.user;
        const post = response.data.post;
        setPost(post);
        setPu(pu);
        dispatch(setSelectedPostGallery(post));
        dispatch(setPostAction(''));
        setShow(true);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };


  const updateActivePost = (post) => {
    axios.get(`/api/posts/${post.id}/details`)
      .then((response) => {
        const pu = response.data.post.user;
        const post = response.data.post;
        setPost(post);
        setPu(pu);
        dispatch(setSelectedPost(post));
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  const handleHide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(setSelectedPost({}));
    // setActiveMedia([]);
  };

  useDidMountEffect(() => {
    if (Object.keys(activeMedia).length > 0) {
      setShow(true);
    }
  }, [activeMedia]);


  useDidMountEffect(() => {
    let mounted = true;

    if (Object.keys(activePost).length === 0) {
      getPosts('new');
      setShow(false);
    }

    if (post.unlocked === false && activePost.unlocked === true) {
      updateActivePost(activePost);
    }

    return (() => { mounted = false; });
  }, [activePost]);

  const pathname = window.location.pathname.replace('/', '');

  useDidMountEffect(() => {
    let source = 'new';
    if (currentPage > 1) {
      source = 'loadMore';
    }

    getPosts(source);
  }, [currentPage]);

  const resetPostLists = () => {
    dispatch(resetPosts());
  };

  useEffect(() => {
    let isMounted = true;

    getPosts('new');

    return () => {
      isMounted = false;

      if (cancelTokenSource.current) {
        cancelTokenSource.current.cancel('Cancel shop request');
      }

      resetPostLists();
      dispatch(setPostWasReset(true));
    };
  }, []);

  const handleClose = () => {
    setShow(false);
    dispatch(setPostAction(''));
  };

  useDidMountEffect(() => {
    if (action === "edit") {
      setShow(false);
    }
  }, [action]);

  useDidMountEffect(() => {
    getPosts('new');
  }, [activeCategory]);

  const handleLike = (index) => {
    const currentLike = !posts[index].is_liked_by_user;
    posts[index].is_liked_by_user = currentLike;

    if (currentLike === false) {
      const userIndex = posts[index].likes.findIndex(like => like.user_id == userInformation.id);
      posts[index].likes.splice(userIndex, 1);
    } else {
      posts[index].likes.push({ user_id: userInformation.id });
    }

    setPosts(
      [...posts],
      posts[index]
    );
  };

  useDidMountEffect(() => {
    let mounted = true;
    if (refetch) {
      setCurrentPage(1);
    }

    return () => {
      mounted = false;
    };
  }, [refetch]);

  const [anchor, setAnchor] = React.useState(null);
  const handleShowFilter = (event) => {
    setAnchor(anchor ? null : event.currentTarget);
  };
  const open = Boolean(anchor);
  const id = open ? 'shop-filter-popup' : undefined;

  const handleFilterChange = (e) => {
    setShopFilter({
      ...shopFilter,
      filter: e.target.value
    });
  };

  useDidMountEffect(() => {
    if (cancelTokenSource.current) {
      cancelTokenSource.current.cancel('Cancel shop request');
    }

    resetPostLists();
    dispatch(setPostWasReset(true));

    getPosts('new');
  }, [shopFilter]);

  const handleOrderChange = (e) => {
    setShopFilter({
      ...shopFilter,
      order: e.target.value
    });
  };

  const handleClick = e => {
    if (!anchor) {
      return;
    }

    const closest = e.target.closest('.shop-filter-container');

    if (!closest) {
      setAnchor(null);
    }
  };

  useEffect(() => {
    // const shopFilterDisplayed = document.getElementsByClassName('.shop-filter-container').lenght > 0;

    setTimeout(() => {
      if (anchor) {
        window.addEventListener('click', handleClick);
      } else {
        window.removeEventListener('click', handleClick);
      }
    }, 100);

    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, [anchor]);

  useEffect(() => {
    const handleUnlockedPost = (e) => {
      setPost(e.detail.post);
    };

    if (show) {
      window.addEventListener('post/unlocked', handleUnlockedPost);
    } else {
      window.removeEventListener('post/unlocked', handleUnlockedPost);
    }

    return () => {
      window.removeEventListener('post/unlocked', handleUnlockedPost);
    };
  }, [show]);

  useEffect(() => {
    $('#pu-content-container').height('fit-content');
  }, [posts]);

  return (
    <>
      <div className="media-contents-container">
        <div className="shop-header">
          <span>PPVs for sale</span>
          <span className="shop-filter-toggler" onClick={handleShowFilter}>
            <i className="fa-regular fa-bars-sort"></i>
          </span>
          <BasePopup id={id} open={open} anchor={anchor} placement="left-start">
            <PopupBody className="shop-filter-container">
              <span className="filter">
                <input
                  type="radio"
                  id="name"
                  name="filter"
                  value="caption"
                  onChange={handleFilterChange}
                  checked={shopFilter.filter === 'caption'}
                />
                <label htmlFor="name">Name</label>
              </span>

              <span className="filter">
                <input
                  type="radio"
                  id="price"
                  name="filter"
                  value="price"
                  onChange={handleFilterChange}
                  checked={shopFilter.filter === 'price'}
                />
                <label htmlFor="price">Price</label>
              </span>

              <span className="filter">
                <input
                  type="radio"
                  id="date"
                  name="filter"
                  value="created_at"
                  onChange={handleFilterChange}
                  checked={shopFilter.filter === 'created_at'}
                />
                <label htmlFor="date">Date</label>
              </span>

              <hr />

              <span className="order">
                <input
                  type="radio"
                  id="asc"
                  name="order"
                  value="asc"
                  onChange={handleOrderChange}
                  checked={shopFilter.order === 'asc'}
                />
                <label htmlFor="asc">Ascending</label>
              </span>

              <span className="order">
                <input
                  type="radio"
                  id="desc"
                  name="order"
                  value="desc"
                  onChange={handleOrderChange}
                  checked={shopFilter.order === 'desc'}
                />
                <label htmlFor="desc">Descending</label>
              </span>
            </PopupBody>
          </BasePopup>
        </div>

        <div className="media-items-container shop">
          {
            posts.map((post, index) => {
              if (posts.length === index + 1) {
                return <ShopItem
                  ref={lastPostElementRef}
                  posts={posts}
                  post={post}
                  pu={user}
                  key={post.id}
                  likeHandler={handleLike}
                  index={index}
                  refetch={refetch}
                  setRefetch={setRefetch}
                  autoplay={false}
                  handleShow={handleShow}
                />;
              } else {
                return <ShopItem
                  posts={posts}
                  post={post}
                  pu={user}
                  key={post.id}
                  likeHandler={handleLike}
                  index={index}
                  refetch={refetch}
                  setRefetch={setRefetch}
                  autoplay={false}
                  handleShow={handleShow}
                />;
              }
            })
          }
          {
            isLoading ?
              <div className="my-4 text-center" style={{ width: '100%' }}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
              :
              posts.length == 0 &&
              <div className="my-4 text-center" style={{ width: '100%' }}>
                <span className="sr-only profile-no-data">No shop items available</span>
              </div>
          }
        </div>
      </div>
      {show && !showCreditCardForm && <Modal
        show={show}
        onHide={handleClose}
        className="media-content-modal post-grid-modal"
        backdrop="static"
        animation={false}
        keyboard={false}
      >
        <Modal.Body className={'post-gallery-container'}>
          <CloseButton
            onClick={handleClose}
            style={{ position: 'absolute', top: '12px', right: '12px', zIndex: 99 }}
          />
          <div className={'post-gallery-body'}>
            {show && <PostItem
              post={post}
              pu={pu}
              key={post.id}
              likeHandler={handleLike}
              index={post.id}
              refetch={refetch}
              setRefetch={setRefetch}
              autoplay={false}
            />}
          </div>
        </Modal.Body>
      </Modal>}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    activePost: state.post.selectedPost,
    postMedias: state.post.postMedias,
    action: state.post.action,
    showCreditCardForm: state.privaGlobal.creditCardForm.show,
    posts: state.post.posts,
    hasMore: state.post.hasMore,
    isLoading: state.post.isLoading,
    isReset: state.post.is_reset,
  };
};

export default React.memo(connect(mapStateToProps)(ShopContents));
